<script lang="ts">
import { MediaServerUrl } from "ts-media-server-url";
import type { Domain, ObjectType, Modifier } from "ts-media-server-url";
import { onDestroy, onMount } from "svelte";
import Loading from "../loading/Loading.svelte";

import {
	canvasWidth,
	canvasHeight,
	canvasTop,
	canvasRight,
	canvasBottom,
	canvasLeft,
	zoom,
	centerOffsetX,
	centerOffsetY,
	imgNaturalWidth,
	imgNaturalHeight,
	imgWidth,
	imgHeight,
	imgX,
	imgY,
	mediaServerUrl,
	userId,
	domain,
	objectType,
	objectId,
	modifiers,
	extension,
	importUrl,
	file,
	hasMultipleChanges,
} from "./store";

import { deleteOne } from "../../api";

const msu = new MediaServerUrl();

let canvas: HTMLDivElement;
let img: HTMLImageElement;
let isLoading: boolean = true;

let imgUrl: string = "";

function msuChange ( ) {
	if (!$hasMultipleChanges) {
		msu.userId     = $userId;
		msu.domain     = $domain;
		msu.objectType = $objectType;
		msu.objectId   = $objectId;
		msu.modifiers  = $modifiers;
		msu.file       = $file;
		msu.extension  = $extension;

		if ($domain === "import") {
			msu.fromImportUrl($importUrl.replace("&resize=4", ""));
		}

		let newUrl = `${$mediaServerUrl}${msu.toString()}`;

		if (newUrl !== imgUrl) {
			isLoading = true;
			imgUrl    = `${$mediaServerUrl}${msu.toString()}`;
		}
	}
}


function windowResize (e?: Event) {
	$canvasWidth = +canvas.clientWidth;
	$canvasHeight = +canvas.clientHeight;
	
	const rect = canvas.getBoundingClientRect();

	$canvasTop    = rect.top;
	$canvasRight  = rect.right;
	$canvasBottom = rect.bottom;
	$canvasLeft   = rect.left;

	center();
	imgPlace();
}

function imgLoad (e?: Event) {
	$imgNaturalWidth = +img.naturalWidth;
	$imgNaturalHeight = +img.naturalHeight;

	getZoomDimensions();
	center();
	imgPlace();
	isLoading = false;
}

function imgPlace ( ) {
	img.style.width  = `${$imgWidth}px`;
	img.style.height = `${$imgHeight}px`;
	img.style.left   = `${$imgX}px`;
	img.style.top    = `${$imgY}px`;
}

function getZoomDimensions ( ) {
	$imgWidth = ( $imgNaturalWidth / 100 ) * $zoom;
	$imgHeight = ( $imgNaturalHeight / 100 ) * $zoom;
}

function center ( ) {
	$imgX = ( ($canvasWidth / 2) - ($imgWidth / 2) );
	$imgY = ( ($canvasHeight / 2) - ($imgHeight / 2) );
}

function canvasWheel (e: WheelEvent) {
	e.preventDefault();
	
	if (e.deltaY < 0) {
		if ($zoom < 1000) {
			$zoom = $zoom + 10;
		}
	} else {
		if ($zoom > 10) {
			$zoom = $zoom - 10;
		}
	}
}

zoom.subscribe(( ) => {
	if (img) {
		getZoomDimensions();
		center();
		imgPlace()
	}
});

let unsubs: Array<() => void> = [];

onMount(( ) => {
	window.addEventListener("resize", windowResize);
	img.addEventListener("load", imgLoad);
	canvas.addEventListener("wheel", canvasWheel);

	unsubs = [
		userId.subscribe(( ) => msuChange()),
		domain.subscribe(( ) => msuChange()),
		objectType.subscribe(( ) => msuChange()),
		objectId.subscribe(( ) => msuChange()),
		modifiers.subscribe(( ) => msuChange()),
		file.subscribe(( ) => msuChange()),
		extension.subscribe(( ) => msuChange()),
	];

	windowResize();
});

onDestroy(( ) => {
	window.removeEventListener("resize", windowResize);
	img.removeEventListener("load", imgLoad);
	canvas.removeEventListener("mousedown", canvasWheel);

	unsubs.forEach((unsub) => {
		unsub();
	})
});
</script>

<div class="playground-canvas" bind:this={canvas}>
	<img class="playground-canvas-img" src={imgUrl} bind:this={img} alt="">
	<Loading {isLoading} class="bg-dark">
		<div class="spinner-border text-light" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</Loading>
</div>

<style>
.playground-canvas {
	width:      100%;
	height:     100%;
	overflow:   hidden;
	position:   relative;
}

.playground-canvas-img {
	position: absolute;
}
</style>
